export const JQueryRequest = {

  // https://api.jquery.com/jquery.ajax/
  url: './',

  request (url, method, data, dwr, callback) {
    // data.csrf_cei_qtoken = Cookies.get('csrf_cei_cookie');
    if (dwr) $$.dom.dwr(true);
    return $.ajax({
      type: method.toUpperCase(),
      url: this.url + url,
      data: data,
      success: function (response, textStatus, jqXHR) {
        $$.notification.parse(response.notification);
        if (callback !== undefined) {
          if (dwr) $$.dom.dwr(false);
          callback(response);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        try {
          let response = JSON.parse(jqXHR.responseText);
          $$.notification.parse(response.notification);
          if (callback !== undefined) {
            if (dwr) $$.dom.dwr(false);
            callback(response);
          }
        } catch (error) {
          $$.notification.show('warning', 'Houve algum erro com o servidor, sua solicitação pode ou não ter sido processada. Por favor consulte o sistema mais tarde para conferir.');
          $$.notification.show('warning', error);
          if (callback !== undefined) {
            if (dwr) $$.dom.dwr(false);
            callback(response);
          }
        }
      }
    }).done(function (response, textStatus, jqXHR) {
      if (dwr) $$.dom.dwr(false);
    });
  },

  upload (url, method, data, dwr, callback) {
    if (dwr) $$.dom.dwr(true);
    $.ajax({
      type: method.toUpperCase(),
      url: this.url + url,
      data: data,
      contentType: false,
      processData: false,
      success: function (response, textStatus, jqXHR) {
        $$.notification.parse(response.notification);
        if (callback !== undefined) {
          if (dwr) $$.dom.dwr(false);
          callback(response);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        let response = JSON.parse(jqXHR.responseText);
        $$.notification.parse(response.notification);
        if (callback !== undefined) {
          if (dwr) $$.dom.dwr(false);
          callback(response);
        }
      }
    }).done(function (response, textStatus, jqXHR) {
      if (dwr) $$.dom.dwr(false);
    });
  }

};